import { type HTMLProps, type ReactElement } from "react";

export default function NoTranslate({
    className,
    children,
    ...props
}: HTMLProps<HTMLSpanElement>): ReactElement {
    const classes = [ "notranslate" ];

    if(typeof className === "string") {
        classes.push(className);
    }

    return (
        <span
            {...props}
            className={classes.join(" ")}
            translate="no"
        >
            {children}
        </span>
    );
}
